<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Masraflar</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption"></div>
              <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                  <li class="m-portlet__nav-item">
                    <div
                      class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
                      m-dropdown-toggle="hover"
                      aria-expanded="true"
                    >
                      <a
                        href="#"
                        class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
                      >
                        <i class="la la-ellipsis-h m--font-brand"></i>
                      </a>
                      <div class="m-dropdown__wrapper" style="z-index: 101;">
                        <span
                          class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                          style="left: auto; right: 21.5px;"
                        ></span>
                        <div class="m-dropdown__inner">
                          <div class="m-dropdown__body">
                            <div class="m-dropdown__content">
                              <ul class="m-nav">
                                <li
                                  class="m-nav__section m-nav__section--first"
                                >
                                  <a
                                    :href="'#/expense/0'"
                                    class="m-nav__section-text"
                                    >Masraf Ekle</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="m-portlet__body">
              <!--begin: Datatable -->
              <div
                id="m_table_1_wrapper"
                class="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px;"
                    >
                      <thead>
                        <tr role="row">
                
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >
                            Kod
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Açıklama
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Talep Tarihi
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Tutar
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Onay Durumu
                          </th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >
                            Onay Tarihi
                          </th>
                          <th
                            class="sorting_disabled"
                            rowspan="1"
                            colspan="1"
                            style="width: 73px;"
                            aria-label="Actions"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="expenses && expenses.length">
                        <tr
                          role="row"
                          class="odd"
                          v-for="expense in expenses"
                          v-bind:key="expense.id"
                        >
                          
                          <td>{{ expense.expenseCode }}</td>
                          <td>{{ expense.description }}</td>
                          <td>
                            {{
                              expense.requestDate
                                | moment(false, "yyyy-MM-dd'T'HH:mm").format(
                                  "DD/MM/YYYY"
                                )
                            }}
                          </td>
                          <td>{{ expense.amount }}</td>
                          <td>{{ expense.approveStatusName }}</td>
                          <td>{{ expense.approveDate }}</td>
                          <td nowrap>
                            <button
                              v-confirm="{
                                ok: dialog => deleteon(dialog,expense)
                              }"
                              class="m-portlet__nav-link btn flaticon-delete m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                            ></button>
                            <a
                              :href="'#/expense/' + expense.id"
                              class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                              title="View"
                            >
                              <i class="la la-edit"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _getAll, _delete } from "../../services/ExpenseService";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      expenses: []
    };
  },
  created() {
    this.getAll();
  },
  methods: {
    getAll() {
      _getAll().then(res => {
        if (res.data.success) this.expenses = res.data.data.items;
      });
    },
    deleteon(dialog, expense) {
      _delete(expense.id).then(res => {
        if (res.data.success) this.getAll();
      });
      dialog.close();
    }
  }
};
</script>
